__turbopack_context__.v({
  "error": "-hoWMG_error",
  "toggleBlock": "-hoWMG_toggleBlock",
  "toggleChip": "-hoWMG_toggleChip",
  "toggleContainer": "-hoWMG_toggleContainer",
  "toggleInput": "-hoWMG_toggleInput",
});
